<template>
    <div class="grid xl:grid-cols-2 gap-4 md:gap-16">
        <div>
            <div class="py-4 pr-6">
                <h3 class="font-bold text-3xl">BESKRIVNING</h3>
                <ul>
                    <li
                        class="list-[square] text-sm md:text-base list-inside"
                        v-for="(item, index) in currentApartment.rentProperties"
                        :key="index">
                        {{ item }}
                    </li>
                </ul>
            </div>
            <div class="py-4">
                <a
                    class="text-sm md:text-base"
                    href="https://www.mimer.nu/hyra-och-bo/for-dig-som-bor-hos-mimer/lagenhetens-underhall/"
                    >Om lägenhetens underhåll</a
                >
            </div>

            <div v-if="currentApartment.rentRows.length >= 1" class="py-4 pr-6">
                <h3 class="font-bold text-3xl">I HYRAN INGÅR</h3>
                <ul>
                    <li
                        class="list-[square] text-sm md:text-base list-inside"
                        v-for="(item, index) in currentApartment.rentRows"
                        :key="index">
                        {{ item.text }}: {{ item.monthRent.split(',')[0] }} kr/månad
                    </li>
                </ul>
            </div>

            <additional-information :notes="currentApartment.notes" />

            <div class="py-4 pr-6">
                <h3 class="font-bold text-3xl">PARKERA BILEN</h3>
                <p class="text-sm md:text-base">
                    <span>
                        På <a href="/sok-ledigt/lediga-parkeringsplatser/">Lediga bilplatser</a> kan du se vilka
                        bilplatser du kan hyra och anmäla intresse.
                    </span>
                    <br />
                    <span>
                        Det finns avgiftsbelagda besöksparkeringar i alla våra områden. Platser för rörelsehindrade
                        besökare är avgiftsfria men kräver handikapptillstånd
                    </span>
                </p>
            </div>
        </div>
        <div>
            <h3 class="font-bold text-3xl">DOKUMENT</h3>
            <div
                class="mb-4"
                v-if="currentApartment.imageUrlList.filter((image) => image.caption == 'Blueprint').length > 0">
                <div v-if="showBlueprint">
                    <img
                        class="w-auto sm:h-[42rem]"
                        :src="currentApartment.imageUrlList.filter((image) => image.caption == 'Blueprint')[0].url"
                        alt="Bild av planritning" />
                </div>
                <div class="pt-4">
                    <mimer-button
                        v-on:click="toggleBlueprint()"
                        :text="showBlueprint ? 'Dölj Planritning' : 'Visa Planritning'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import AdditionalInformation from '@/components/Common/AdditionalInformation.vue';
import { MimerButton } from 'mimer-components';

defineProps({
    currentApartment: {
        type: Object,
        required: true,
    },
});

const showBlueprint = ref(true);

const toggleBlueprint = () => {
    showBlueprint.value = !showBlueprint.value;
};
</script>
